/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiWire = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8.15 17.09 5.798 6.91h1.764l1.68 7.448 2.002-6.888h1.498l2.072 6.93 1.68-7.49h1.708L15.85 17.09h-1.68l-2.198-7.266L9.83 17.09H8.15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiWire as PmiWire };
